// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  background: transparent;
  all: initial;
  * {
    all: unset;
  }
}

#chatbot-root {
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji",
    "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  bottom: 20px;
  position: fixed;
  right: 20px;
  z-index: 1000;
  pointer-events: none;
}

.app-chatbot-button {
  width: 60px;
  height: 60px;
  border-radius: 30px;
  padding: 10px;
  fill: #fff;
  background-color: #2b2b2b;
  border: none;
  position: relative;
  z-index: 9999;
  float: right;
  top: 5px;
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: transform 0.6s ease-in-out;
  pointer-events: all;
}
.app-chatbot-button:hover {
  transform: scale(1.1);
}

.App {
  bottom: 20px;
  height: calc(100% - 40px);
  margin: auto;
  max-height: 600px;
  position: fixed;
  right: 20px;
}

.App-header {
  align-items: end;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  height: 100%;
  justify-content: end;
}

.react-chatbot-kit-chat-container {
  border-color: rgb(216, 216, 216) currentcolor currentcolor;
  border-style: solid none none;
  border-width: 1px medium medium;
  height: 100%;
  width: 320px;
}

.react-chatbot-kit-chat-header {
  background-color: #2b2b2b;
  color: white;
  margin-left: calc(-1 * var(--bs-card-border-width));
  margin-top: -2px;
  width: calc(320px + 2 * var(--bs-card-border-width));
}

.react-chatbot-kit-chat-input-container {
  width: 320px;
}

.react-chatbot-kit-chat-input-form {
  width: 320px;
}

.react-chatbot-kit-chat-input {
  width: 220px;
}

.react-chatbot-kit-chat-input:focus {
  outline: none;
}

.react-chatbot-kit-chat-message-container {
  flex-grow: 1;
  max-height: calc(100% - 80px);
  overflow-x: hidden;
  overflow-y: auto;
  padding: 0 17.5px 10px 1.5px;
  width: 320px;
}

.react-chatbot-kit-chat-bot-avatar-img {
  background: none;
  width: 45px;
  height: 45px;
  overflow: hidden;
  margin-left: 0.5rem;
  margin-right: 0.5rem;
  border-radius: 100%;
}

.react-chatbot-kit-chat-bot-avatar-blank {
  background: #cccccc;
  width: 45px;
  height: 45px;
  overflow: hidden;
  margin-left: 0.5rem;
  margin-right: 0.5rem;
  border-radius: 100%;
}

.react-chatbot-kit-chat-bot-message {
  background-color: #f1f1f1;
  color: #2b2b2b;
  margin-left: 0px;
  width: 200px;
}

.react-chatbot-kit-chat-bot-message a {
  text-decoration: underline;
}

.react-chatbot-kit-chat-bot-message-arrow {
  border-right: 8px solid #f1f1f1;
  top: 22px;
}

.react-chatbot-kit-user-chat-message {
  width: 200px;
}

.react-chatbot-kit-user-avatar-container {
  background-color: #64d431;
}

.react-chatbot-kit-chat-btn-send {
  margin-bottom: calc(-1 * var(--bs-card-border-width));
  margin-right: calc(-1 * var(--bs-card-border-width));
  width: 101px;
  filter: brightness(60%);
  cursor: not-allowed;
  transition: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 100ms;
}

.react-chatbot-kit-chat-btn-send-valid {
  filter: brightness(100%);
  cursor: pointer;
}

.react-chatbot-kit-chat-btn-send-icon {
  width: 20px;
}

.react-chatbot-kit-user-avatar-icon {
  width: 20px;
  height: 20px;
}

.react-chatbot-kit-chat-inner-container {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.close-chatbot-icon {
  margin-top: 2px;
  width: 35px;
}

.open-chatbot-icon {
  margin-top: 5px;
  width: 35px;
}

/* Style for the close button container */
.chatbot-close-button {
  position: absolute;
  top: 3px;
  right: 10px;
  cursor: pointer;
  background-color: #2b2b2b;
  border-radius: 50%;
  padding: 5px;
  z-index: 1001;
}

/* Style for the close button SVG */
.chatbot-close-button svg {
  fill: #fff;
  width: 24px;
  height: 24px;
}

a {
  text-decoration: none;
}

.react-reveal.card {
  border-radius: 5px;
  border: 1px solid rgb(216, 216, 216);
  height: calc(100% - 80px);
  max-height: 600px;
  min-width: 320px;
  overflow: hidden;
  pointer-events: all;
}

.react-reveal.card > div:not(.chatbot-close-button) {
  height: 100%;
}

.react-reveal.card > div > div {
  height: 100%;
}

.options {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.suggested-option {
  border: 1px solid #173e3f;
  border-radius: 25px;
  color: #1d1d1d;
  font-size: 0.8rem;
  margin: 4px;
  padding: 8px;
  transition: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.suggested-option:hover {
  background: #e4e4e4;
}

.attribution {
  display: flex;
  box-sizing: content-box;
  background: #dddddd;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  border-top: 1px solid #bbbbbb;
  bottom: 0;
  color: #777777;
  font-size: 0.75rem;
  padding: 0.25rem 0.75rem 0.35rem 0.75rem;
  position: absolute;
  width: 320px;
  transition-property: color;
  transition-duration: 150ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

.attribution:hover {
  color: #333333;
}
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,YAAY;EACZ;IACE,UAAU;EACZ;AACF;;AAEA;EACE;2DACyD;EACzD,YAAY;EACZ,eAAe;EACf,WAAW;EACX,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,UAAU;EACV,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,sCAAsC;EACtC,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,0DAA0D;EAC1D,6BAA6B;EAC7B,+BAA+B;EAC/B,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,mDAAmD;EACnD,gBAAgB;EAChB,oDAAoD;AACtD;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;EAC/B,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qDAAqD;EACrD,oDAAoD;EACpD,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,wDAAwD;EACxD,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA,yCAAyC;AACzC;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,aAAa;AACf;;AAEA,mCAAmC;AACnC;EACE,UAAU;EACV,WAAW;EACX,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;EACpC,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,wDAAwD;EACxD,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,8BAA8B;EAC9B,+BAA+B;EAC/B,6BAA6B;EAC7B,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,wCAAwC;EACxC,kBAAkB;EAClB,YAAY;EACZ,0BAA0B;EAC1B,0BAA0B;EAC1B,wDAAwD;AAC1D;;AAEA;EACE,cAAc;AAChB","sourcesContent":["body {\n  background: transparent;\n  all: initial;\n  * {\n    all: unset;\n  }\n}\n\n#chatbot-root {\n  font-family: ui-sans-serif, system-ui, sans-serif, \"Apple Color Emoji\",\n    \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n  bottom: 20px;\n  position: fixed;\n  right: 20px;\n  z-index: 1000;\n  pointer-events: none;\n}\n\n.app-chatbot-button {\n  width: 60px;\n  height: 60px;\n  border-radius: 30px;\n  padding: 10px;\n  fill: #fff;\n  background-color: #2b2b2b;\n  border: none;\n  position: relative;\n  z-index: 9999;\n  float: right;\n  top: 5px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  transition: transform 0.6s ease-in-out;\n  pointer-events: all;\n}\n.app-chatbot-button:hover {\n  transform: scale(1.1);\n}\n\n.App {\n  bottom: 20px;\n  height: calc(100% - 40px);\n  margin: auto;\n  max-height: 600px;\n  position: fixed;\n  right: 20px;\n}\n\n.App-header {\n  align-items: end;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  height: 100%;\n  justify-content: end;\n}\n\n.react-chatbot-kit-chat-container {\n  border-color: rgb(216, 216, 216) currentcolor currentcolor;\n  border-style: solid none none;\n  border-width: 1px medium medium;\n  height: 100%;\n  width: 320px;\n}\n\n.react-chatbot-kit-chat-header {\n  background-color: #2b2b2b;\n  color: white;\n  margin-left: calc(-1 * var(--bs-card-border-width));\n  margin-top: -2px;\n  width: calc(320px + 2 * var(--bs-card-border-width));\n}\n\n.react-chatbot-kit-chat-input-container {\n  width: 320px;\n}\n\n.react-chatbot-kit-chat-input-form {\n  width: 320px;\n}\n\n.react-chatbot-kit-chat-input {\n  width: 220px;\n}\n\n.react-chatbot-kit-chat-input:focus {\n  outline: none;\n}\n\n.react-chatbot-kit-chat-message-container {\n  flex-grow: 1;\n  max-height: calc(100% - 80px);\n  overflow-x: hidden;\n  overflow-y: auto;\n  padding: 0 17.5px 10px 1.5px;\n  width: 320px;\n}\n\n.react-chatbot-kit-chat-bot-avatar-img {\n  background: none;\n  width: 45px;\n  height: 45px;\n  overflow: hidden;\n  margin-left: 0.5rem;\n  margin-right: 0.5rem;\n  border-radius: 100%;\n}\n\n.react-chatbot-kit-chat-bot-avatar-blank {\n  background: #cccccc;\n  width: 45px;\n  height: 45px;\n  overflow: hidden;\n  margin-left: 0.5rem;\n  margin-right: 0.5rem;\n  border-radius: 100%;\n}\n\n.react-chatbot-kit-chat-bot-message {\n  background-color: #f1f1f1;\n  color: #2b2b2b;\n  margin-left: 0px;\n  width: 200px;\n}\n\n.react-chatbot-kit-chat-bot-message a {\n  text-decoration: underline;\n}\n\n.react-chatbot-kit-chat-bot-message-arrow {\n  border-right: 8px solid #f1f1f1;\n  top: 22px;\n}\n\n.react-chatbot-kit-user-chat-message {\n  width: 200px;\n}\n\n.react-chatbot-kit-user-avatar-container {\n  background-color: #64d431;\n}\n\n.react-chatbot-kit-chat-btn-send {\n  margin-bottom: calc(-1 * var(--bs-card-border-width));\n  margin-right: calc(-1 * var(--bs-card-border-width));\n  width: 101px;\n  filter: brightness(60%);\n  cursor: not-allowed;\n  transition: all;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  transition-duration: 100ms;\n}\n\n.react-chatbot-kit-chat-btn-send-valid {\n  filter: brightness(100%);\n  cursor: pointer;\n}\n\n.react-chatbot-kit-chat-btn-send-icon {\n  width: 20px;\n}\n\n.react-chatbot-kit-user-avatar-icon {\n  width: 20px;\n  height: 20px;\n}\n\n.react-chatbot-kit-chat-inner-container {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.close-chatbot-icon {\n  margin-top: 2px;\n  width: 35px;\n}\n\n.open-chatbot-icon {\n  margin-top: 5px;\n  width: 35px;\n}\n\n/* Style for the close button container */\n.chatbot-close-button {\n  position: absolute;\n  top: 3px;\n  right: 10px;\n  cursor: pointer;\n  background-color: #2b2b2b;\n  border-radius: 50%;\n  padding: 5px;\n  z-index: 1001;\n}\n\n/* Style for the close button SVG */\n.chatbot-close-button svg {\n  fill: #fff;\n  width: 24px;\n  height: 24px;\n}\n\na {\n  text-decoration: none;\n}\n\n.react-reveal.card {\n  border-radius: 5px;\n  border: 1px solid rgb(216, 216, 216);\n  height: calc(100% - 80px);\n  max-height: 600px;\n  min-width: 320px;\n  overflow: hidden;\n  pointer-events: all;\n}\n\n.react-reveal.card > div:not(.chatbot-close-button) {\n  height: 100%;\n}\n\n.react-reveal.card > div > div {\n  height: 100%;\n}\n\n.options {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n}\n\n.suggested-option {\n  border: 1px solid #173e3f;\n  border-radius: 25px;\n  color: #1d1d1d;\n  font-size: 0.8rem;\n  margin: 4px;\n  padding: 8px;\n  transition: all;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  transition-duration: 150ms;\n}\n\n.suggested-option:hover {\n  background: #e4e4e4;\n}\n\n.attribution {\n  display: flex;\n  box-sizing: content-box;\n  background: #dddddd;\n  border-bottom-left-radius: 5px;\n  border-bottom-right-radius: 5px;\n  border-top: 1px solid #bbbbbb;\n  bottom: 0;\n  color: #777777;\n  font-size: 0.75rem;\n  padding: 0.25rem 0.75rem 0.35rem 0.75rem;\n  position: absolute;\n  width: 320px;\n  transition-property: color;\n  transition-duration: 150ms;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.attribution:hover {\n  color: #333333;\n}\n"],"sourceRoot":""}]);
// Exports
var ___CSS_LOADER_STYLE_SHEET___ = new CSSStyleSheet();
___CSS_LOADER_STYLE_SHEET___.replaceSync(___CSS_LOADER_EXPORT___.toString());
export default ___CSS_LOADER_STYLE_SHEET___;
